<template>
<div class="boxesContainer widthFull mb-4">


  <!-- MB FACTA ***************************************************************************************************************
  <div class="cardBox mb-4" style="" :class="{'is-flipped' : card1}">
    <div class="cardFlow">
      <div class="front vaillantCont">

        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b>ISTITUTO DI CREDITO</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-md-3 uppercase"><b>Flusso completo</b></p>

        <h4 class="mt-0 pt-0" :class="{'pb-md-0': mbfactaState == 'pending' || mbfactaState == 'await_contract' || mbfactaState == 'active'  }">
          <b> Stato:
            <span v-if="mbfactaState == 'not_active'" class="grey"> Non Abilitato </span> <span v-if="mbfactaState == 'not_active'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(4)"> ABILITA
            </span>
            <span v-if="mbfactaState == 'pending' || mbfactaState == 'await_contract'" class="yellow "> Documentazione in verifica </span>
            <span v-if="mbfactaState == 'error'" class="red"> Rilevato anomalia/e</span> <span v-if="mbfactaState == 'error'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(4)"> SCOPRI DI PIÙ
            </span>
            <span v-if="mbfactaState == 'renew'" class="red"> Sospeso </span> <span v-if="mbfactaState == 'renew'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(4)">
              SCOPRI DI PIÙ
            </span>
            <span v-if="mbfactaState == 'active'" class="green  "> Abilitato </span>
          </b>
        </h4>
        <div class="container">

          <div class="row justify-content-center text-center">
            <div class="col-6 center text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue mt-2 pt-0 mb-0 center h2 "> <b class="green">{{ 100 - finance_cost_mbfacta }}%</b> </h1>
                  <p class="quardDescription mt-0 pt-0 center mb-0"><b>Valore  nominale <br/> di cessione </b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center text-center pr-2 pl-2 mt-2">

              <div class="quardContainer bluetify">
                <p class="quardDescription mt-2 pt-0 center mb-0"><b>a partire da<br /></b></p>
                <h1 class="quardValue mt-0 pt-0 mb-0 center h2 "><b class="green"> € {{practic_price_mbfacta_old}}<small><b>+IVA</b></small> </b> </h1>
                <p class="quardDescription mt-0 pt-0 center mb-0"><b>Costo Pratica Base (*) <br /> con Due Diligence  </b></p>
              </div>

            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue center h2  mt-2 pt-0 mb-0"> <b>
                      <font-awesome-icon icon="user-check" size="1x" />
                    </b> </h1>
                  <p class="quardDescription center mb-0"><b>Verifica Criteri di Eleggibilità <br/> ISTITUTO DI CREDITO</b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue  mt-2 pt-0 mb-0 center h2 "> <b> € {{ min_disposals_price_mbfacta | formatNumberNoDecimals }} </b> </h1>
                  <p class="quardDescription center mb-0"><b>Importo minimo di cessione<br/>   cumulato in max 3 mesi </b></p>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="back vaillantCont scrollContainer">
        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b>ISTITUTO DI CREDITO</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-md-3 uppercase"><b>Flusso completo</b></p>
        <ul class="newBackDesc text-left pt-md-4 ">
          <li>
            Valore nominale di cessione: <b>{{ 100 - finance_cost_mbfacta }}%*</b>
            <br /> (* potenzialmente soggetto ad eventuali variazioni da parte di ISTITUTO DI CREDITO)
          </li>
          <li>
            <b>Costo Pratica</b> (importo Pratica base)
            <br /> <b>TQSA ≤ € {{ tqsa  }} IVA incl. o Edilizia Libera</b>  <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence e comunicazione web cessione credito da cliente ad installatore: <b>€{{practic_price_mbfacta_old}}+IVA</b>
            <br /> <b>TQSA > € {{ tqsa  }} IVA incl. e NO Edilizia Libera</b>
            <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence, Visto di Conformità e comunicazione web cessione credito da cliente ad installatore: <b>€{{ practic_price_mbfacta + practice_visto }}+IVA</b>
          </li>


          <li>
            Riferimento Bonus Fiscali: <b>EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%</b>
          </li>
          <li>
            Partner: <b>ISTITUTO DI CREDITO</b>
          </li>
          <li>
            Advisor: <b>ADVISOR PARTNER</b>
          </li>
          <li>
            Tempo medio di liquidazione: <b>30 giorni lavorativi da credito disponibile nel cassetto fiscale di ISTITUTO DI CREDITO **</b>
            <br /> (** potenzialmente soggetto ad eventuali variazioni da parte di ISTITUTO DI CREDITO)
          </li>

        </ul>

        <p class="center h5 mb-0 pb-0">Requisiti per cessione a ISTITUTO DI CREDITO: </p>

        <ul class="newBackDesc text-left pt-2 pb-0">
          <li>
            Requisiti base PMI <b class="underline pointer" v-on:click="setSection(4)">(elenco QUI)</b>
          </li>
          <li>
            Inserimento documenti per <b>verifica Criteri di Eleggibilità ISTITUTO DI CREDITO</b> (inserimento e attesa validazione documenti nella sezione Documenti per Eleggibilità ISTITUTO DI CREDITO <b class="underline pointer" v-on:click="setSection(4)">cliccando
              QUI</b>)
          </li>
          <li>
            Sottoscrizione del <b>contratto di cessione del credito con ISTITUTO DI CREDITO</b> per ogni cessione
          </li>
          <li>
            <b>Importo minimo per singola cessione a ISTITUTO DI CREDITO</b> (anche cumulando più Pratiche già pagate in piattaforma relative alla cessione a ISTITUTO DI CREDITO): <b>€ {{ min_disposals_price_mbfacta | formatNumberNoDecimals }} in max 3 mesi </b>

          </li>
        </ul>

      </div>
      <div ref="mbfacta" class="cardFooter">

        <h5 v-if="card1" v-on:click="toggleCard(1)"  class="pointer mb-2 pb-2 mt-2" :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">
          <font-awesome-icon class="mr-3" icon="arrow-left" size="1x" /> Indietro
        </h5>
        <h5 v-else v-on:click="toggleCard(1)"  class="pointer mb-2 pb-2 mt-2" :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">Scopri di piu
          <font-awesome-icon class="ml-3" icon="arrow-right" size="1x" />
        </h5>

        <h5 v-if="hasSelectButtons && flow_mbfacta_active && mbfactaState == 'active'" v-on:click="setChoice('mbfacta')" class="center underline pointer brTop mt-0 pt-2">
           <span class="mt-2">Procedi con ISTITUTO DI CREDITO</span>
        </h5>

        <h5 v-if="hasSelectButtons && flow_mbfacta_active && mbfactaState != 'active'"  class="center disabled red pointer brTop mt-0 pt-2 smallTxt">
           <span class="mt-2 Bold">Puoi procedere solo se il flusso è abilitato </span>
        </h5>

        <h5 v-if="hasSelectButtons && !flow_mbfacta_active" class="center  pointer brTop mt-0 pt-2 black smallTxt "  disabled v-html="mbfacta_not_active_text">  </h5>

      </div>
    </div>
  </div>
  -->
  <!-- AGILE ENERGY *************************************************************************************************************** -->
  <div class="cardBox mb-4" style="" :class="{'is-flipped' : card4}">
    <div class="cardFlow">
      <div class="front vaillantCont">

        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b class="uppercase">Agile Energy</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-md-3 uppercase"><b>Flusso General Contractor <small> </small></b></p>

        <h4 class="mt-0 pt-0" :class="{'pb-md-0': aeState == 'pending' || aeState == 'active'  }">
          <b> Stato:
            <span v-if="aeState == 'not_active'" class="grey"> Non Abilitato </span> <span v-if="aeState == 'not_active'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(3)"> ABILITA
            </span>
            <span v-if="aeState == 'pending'" class="yellow "> Documentazione in verifica </span>
            <span v-if="aeState == 'await_contract'" class="yellow "> In attesa del Contratto </span>

            <span v-if="aeState == 'error'" class="red"> Rilevato anomalia/e</span> <span v-if="aeState == 'error'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(3)"> SCOPRI DI PIÙ
            </span>
            <span v-if="aeState == 'renew'" class="red"> Sospeso </span> <span v-if="aeState == 'renew'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(3)">
              SCOPRI DI PIÙ
            </span>
            <span v-if="aeState == 'active'" class="green  "> Abilitato </span>
          </b>
        </h4>
        <div class="container">
          <!---     QUARD      ZONE        -->
          <div class="row justify-content-center text-center">
            <div class="col-6 center text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue mt-2 pt-0 mb-0 center h2 "> <b class="">{{ 100 - finance_cost_agileenergy }}%</b> </h1>
                  <p class="quardDescription mt-0 pt-0 center mb-0"><b>Valore  nominale  di cessione  </b></p>
                  <p class="quardDescription mt-0 pt-0 center mb-0 red"><b>Potenzialmente soggetto <br/>ad eventuali variazioni  </b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center text-center pr-2 pl-2 mt-2">

              <div class="quardContainer bluetify">
                <h1 class="quardValue mt-0 pt-2 mb-0 center h2 "><b class=""> € {{ practic_price_agileenergy_old }}<small><b>+IVA</b></small> </b> </h1>
                <p class="quardDescription mt-0 pt-0 center mb-0"><b>Costo Pratica <br/> per il committente <br /> con Due Diligence  </b></p>
              </div>

            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue center h2  mt-2 pt-0 mb-0"> <b>
                      <font-awesome-icon icon="user-check" size="1x" />
                    </b> </h1>
                  <p class="quardDescription center mb-0"><b>Verifica Criteri di Eleggibilità <br/> AGILE ENERGY</b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue  mt-2 pt-0 mb-0 center h2 "> <b> € {{ 15000 | formatNumberNoDecimals }}  </b> </h1>
                  <p class="quardDescription center mb-0"><b>Importo massimo  fattura<br/>  per intervento ( Edilizia Libera )  </b></p>
                </div>
              </div>
            </div>
          </div>
          <!---   END  QUARD  ZONE        -->
        </div>

      </div>
      <div class="back vaillantCont scrollContainer">
        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b class="uppercase">AGILE ENERGY</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-2 mb-md-3 Bold"><b>FLUSSO COMPLETO GENERAL CONTRACTOR</b> </p>
        <ul class="newBackDesc text-left pt-md-4 ">
          <li>
            Valore nominale di cessione: <b>{{ 100 - finance_cost_agileenergy }}%*</b> a carico del committente
            <br /> (* potenzialmente soggetto ad eventuali variazioni da parte di AGILE ENERGY)
          </li>
          <li>
            <b>Costo Pratica Base al commitente <b class="red">esclusi costi di gestione e servizi AGILE ENERGY</b></b> (importo Pratica base)
            <br /> <b>TQSA ≤ € {{ tqsa  }} IVA incl. ( Edilizia Libera o NO Edilizia Libera )</b>  <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence e comunicazione web cessione credito da cliente ad installatore: <b>€{{practic_price_mbfacta_old}}+IVA</b>
            <br /> <b>TQSA > € {{ tqsa  }} IVA incl. ma ≤ 15.000 IVA incl. <b class="red">SOLO Edilizia Libera</b></b>
            <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence, Visto di Conformità e comunicazione web cessione credito da cliente ad installatore: <b>€{{ practic_price_mbfacta_old }}+IVA</b>
          </li>


          <li >
            <b >Costo di gestione e servizi AGILE ENERGY a carico dell'installatore in subappalto: <b class="green">  €300+IVA</b></b>
            <!--
            <br /> <b>TOTALE IMPONIBILE INTERVENTO ≤ €  5.000 </b> =  <b class="green">  €680+IVA</b>
            <br /> <b>TOTALE IMPONIBILE INTERVENTO > 5.000 e TQSA ≤ €  10.000 </b> =  <b class="green">  €1.320+IVA</b>
            <br /> <b>TOTALE IMPONIBILE INTERVENTO > 10.000 e TQSA ≤ €  15.000 </b> =  <b class="green">  €1.970+IVA</b>
          -->
          </li>
          <li>
            Riferimento Bonus Fiscali: <b>EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%</b>
          </li>
          <li>
            Partner: <b>AGILE ENERGY</b>
          </li>
          <li>
            Tempo medio di liquidazione:
              <br/>- Primo Pagamento: <b>30% del TOTALE IMPONIBILE INTERVENTO a Rimessa Diretta dopo validazione documentale e Due Diligence da parte dell'Advisor incaricato </b>
              <br/>- Saldo Pagamento <b>70% del TOTALE IMPONIBILE INTERVENTO a 30 giorni D.F.F.M. da credito disponibile nel cassetto fiscale di AGILE ENERGY</b>

            <br /> (** potenzialmente soggetto ad eventuali variazioni da parte di AGILE ENERGY)
          </li>
        </ul>

        <p class="center h5 mb-0 pb-0">Requisiti per cessione ad AGILE ENERGY: </p>

        <ul class="newBackDesc text-left pt-2 pb-0">
          <li>
            Requisiti base PMI <b class="underline pointer" v-on:click="setSection(3)">(elenco QUI)</b>
          </li>
          <li>
            Inserimento documenti per <b>verifica Criteri di Eleggibilità AGILE ENERGY</b> (inserimento e attesa validazione documenti nella sezione Documenti per Eleggibilità Agile Energy <b class="underline pointer" v-on:click="setSection(3)">cliccando
              QUI</b>)
          </li>
          <li>
            Sottoscrizione del <b>contratto di Subappalto con AGILE ENERGY</b> per ogni Pratica
          </li>

        </ul>

      </div>
      <div ref="agileenergy" class="cardFooter">

        <h5 v-if="card4" v-on:click="toggleCard(4)"  class="pointer mb-2 pb-2 mt-2" :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">
          <font-awesome-icon class="mr-3" icon="arrow-left" size="1x" /> Indietro
        </h5>
        <h5 v-else v-on:click="toggleCard(4)"  class="pointer mb-2 pb-2 mt-2" :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">Scopri di piu
          <font-awesome-icon class="ml-3" icon="arrow-right" size="1x" />
        </h5>

        <h5 v-if="hasSelectButtons && flow_ae_active && aeState == 'active'" v-on:click="setChoice('agileenergy')" class="center underline pointer brTop mt-0 pt-2">
           <span class="mt-2">Procedi con AGILE ENERGY</span>
        </h5>

        <h5 v-if="hasSelectButtons && flow_ae_active && aeState != 'active'"  class="center disabled red pointer brTop mt-0 pt-2 smallTxt">
           <span class="mt-2 Bold">Puoi procedere solo se il flusso è abilitato </span>
        </h5>

        <h5 v-if="hasSelectButtons && !flow_ae_active" class="center  pointer brTop mt-0 pt-2 black smallTxt "  disabled v-html="ae_not_active_text">  </h5>

      </div>
    </div>
  </div>



  <!-- FLUSSO PERSONALIZZATO ***************************************************************************************************************
  <div class="cardBox mb-4" style="" :class="{'is-flipped' : card2}">
    <div class="cardFlow">
      <div class="front vaillantCont">

        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b>Flusso PERSONALIZZATO</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-md-3 red uppercase"><b>Flusso Speciale solo per Pratiche esterne</b></p>

        <h4 class="mt-0 pt-0" :class="{'pb-md-0': mbfactaState == 'pending' || mbfactaState == 'await_contract' || mbfactaState == 'active'  }">
          <b> Stato:
            <span v-if="mbfactaState == 'not_active'" class="grey"> Non Abilitato </span> <span v-if="mbfactaState == 'not_active'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(4)"> ABILITA
            </span>
            <span v-if="mbfactaState == 'pending' || mbfactaState == 'await_contract'" class="yellow "> Documentazione in verifica </span>
            <span v-if="mbfactaState == 'error'" class="red"> Rilevato anomalia/e</span> <span v-if="mbfactaState == 'error'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(4)"> SCOPRI DI PIÙ
            </span>
            <span v-if="mbfactaState == 'renew'" class="red"> Sospeso </span> <span v-if="mbfactaState == 'renew'" class="mt-3 btn btn-secondary btn-sm ml-4" style="vertical-align: unset;" v-on:click="setSection(4)">
              SCOPRI DI PIÙ
            </span>
            <span v-if="mbfactaState == 'active'" class="green  "> Abilitato </span>
          </b>
        </h4>
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-6 center text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue mt-2 pt-0 mb-0 center h2 "> <b class="green">{{ 100 - finance_cost_mbfacta_recovery }}%</b> </h1>
                  <p class="quardDescription mt-0 pt-0 center mb-0"><b>Valore  nominale <br/> di cessione </b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center text-center pr-2 pl-2 mt-2">

              <div class="quardContainer bluetify">
                <p class="quardDescription mt-2 pt-0 center mb-0"><b>a partire da<br /></b></p>
                <h1 class="quardValue mt-0 pt-0 mb-0 center h2 "><b class="green"> € {{practic_price_mbfacta_recovery_old}}<small><b>+IVA</b></small> </b> </h1>
                <p class="quardDescription mt-0 pt-0 center mb-0"><b>Costo Pratica Base (*) <br /> con Due Diligence  </b></p>
              </div>

            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue center h2  mt-2 pt-0 mb-0"> <b>
                      <font-awesome-icon icon="user-check" size="1x" />
                    </b> </h1>
                  <p class="quardDescription center mb-0"><b>Verifica Criteri di Eleggibilità <br/> ISTITUTO DI CREDITO</b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue  mt-2 pt-0 mb-0 center h2 "> <b> € {{ min_disposals_price_mbfacta_recovery  | formatNumberNoDecimals }} </b> </h1>
                  <p class="quardDescription center mb-0"><b>Importo minimo di cessione <br/> cumulato in max 3 mesi </b></p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="back vaillantCont scrollContainer">
        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b>Flusso PERSONALIZZATO</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-md-3 red uppercase"><b>Flusso Speciale solo per Pratiche esterne</b></p>
        <ul class="newBackDesc text-left pt-md-4 ">
          <li>
            Valore nominale di cessione: <b>{{ 100 - finance_cost_mbfacta_recovery  }}%*</b>
            <br /> (* potenzialmente soggetto ad eventuali variazioni da parte di ISTITUTO DI CREDITO)
          </li>
          <li>
            <b>Costo Pratica</b> ( <b class="red">solo Pratiche esterne con credito già disponible nel cassetto fiscale del installatore </b>)
            <br /> <b>TQSA ≤ € {{ tqsa  }} IVA incl. o Edilizia Libera</b>  <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence e gestione cessione del credito da installatore a cessionario (nel casi previsti) : <b>€{{210}}+IVA</b>
            <br /> <b>TQSA > € {{ tqsa  }} IVA incl. e NO Edilizia Libera</b>
            <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence, Visto di Conformità  e gestione cessione del credito da installatore a cessionario (nel casi previsti): <b>€{{ 220 + practice_visto }}+IVA</b>
          </li>
          <li>
            Riferimento Bonus Fiscali: <b>EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%</b>
          </li>
          <li>
            Partner: <b>ISTITUTO DI CREDITO</b>
          </li>
          <li>
            Advisor: <b>ADVISOR PARTNER</b>
          </li>
          <li>
            Tempo medio di liquidazione: <b>30 giorni lavorativi da credito disponibile nel cassetto fiscale di ISTITUTO DI CREDITO **</b>
            <br /> (** potenzialmente soggetto ad eventuali variazioni da parte di ISTITUTO DI CREDITO)
          </li>
        </ul>
        <p class="center h5 mb-0 pb-0">Requisiti per cessione a ISTITUTO DI CREDITO: </p>
        <ul class="newBackDesc text-left pt-2 pb-0">
          <li>
            Requisiti base PMI <b class="underline pointer" v-on:click="setSection(4)">(elenco QUI)</b>
          </li>
          <li>
            Inserimento documenti per <b>verifica Criteri di Eleggibilità ISTITUTO DI CREDITO</b> (inserimento e attesa validazione documenti nella sezione Documenti per Eleggibilità ISTITUTO DI CREDITO <b class="underline pointer" v-on:click="setSection(4)">cliccando
              QUI</b>)
          </li>
          <li>
            Sottoscrizione del <b>contratto di cessione del credito con ISTITUTO DI CREDITO</b> per ogni cessione
          </li>
          <li>
            <b>Importo minimo per singola cessione a ISTITUTO DI CREDITO</b> (anche cumulando più Pratiche già pagate in piattaforma relative alla cessione a ISTITUTO DI CREDITO): <b>€ {{ min_disposals_price_mbfacta_recovery  | formatNumberNoDecimals }} in max 3 mesi </b>

          </li>
        </ul>

      </div>
      <div ref="mbfacta_recovery" class="cardFooter">

        <h5 v-if="card2" v-on:click="toggleCard(2)"  class="pointer mb-2 pb-2 mt-2" :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">
          <font-awesome-icon class="mr-3" icon="arrow-left" size="1x" /> Indietro
        </h5>
        <h5 v-else v-on:click="toggleCard(2)"  class="pointer mb-2 pb-2 mt-2" :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">Scopri di piu
          <font-awesome-icon class="ml-3" icon="arrow-right" size="1x" />
        </h5>

        <h5 v-if="hasSelectButtons && flow_mbfacta_recovery_active && mbfactaState == 'active'" v-on:click="setChoice('mbfacta_recovery')" class="center underline pointer brTop mt-0 pt-2">
           <span class="mt-2">Procedi con Flusso Personalizzato</span>
        </h5>

        <h5 v-if="hasSelectButtons && flow_mbfacta_recovery_active && mbfactaState != 'active'"  class="center disabled red pointer brTop mt-0 pt-2 smallTxt">
           <span class="mt-2 Bold">Puoi procedere solo se il flusso è abilitato </span>
        </h5>

        <h5 v-if="hasSelectButtons && !flow_mbfacta_recovery_active" class="center  pointer brTop mt-0 pt-2 black smallTxt "  disabled v-html="mbfacta_recovery_not_active_text">  </h5>

      </div>
    </div>
  </div>
  -->

  <!-- FLUSSO BASE *************************************************************************************************************** -->
  <div class="cardBox mb-4" style="" :class="{'is-flipped' : card3}">
    <div class="cardFlow">
      <div class="front vaillantCont">

        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b>Flusso BASE</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-md-3 uppercase red Bold"><b>Senza Cessione del Credito</b> </p>

        <h4 class="mt-0 pt-0" :class="{'pb-md-0': cdpState == 'pending' || cdpState == 'active'  }">
          <b> Stato :
            <span  class="green  "> Abilitato </span>
          </b>
        </h4>
        <div class="container">
          <!---     QUARD      ZONE        -->
          <div class="row justify-content-center text-center">

            <div class="col-6 center text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue mt-2 pt-0 mb-0 center h2 "> <b>XX %</b> </h1>
                  <p class="quardDescription mt-0 pt-0 center mb-0"><b>Valore nominale di cessione </b></p>
                  <p class="quardDescription mt-0 pt-0 center mb-0 red uppercase"><b>modificabile liberalmente <br/> dall'aderente  </b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center text-center pr-2 pl-2 mt-1 mt-md-2">

              <div class="quardContainer bluetify">
                <p class="quardDescription mt-2 pt-0 center mb-0"><b>a partire da<br /></b></p>
                <h1 class="quardValue mt-0 pt-0 mb-0 center h2 "><b class=""> € 230<small><b>+IVA</b></small> </b> </h1>

                <p class="quardDescription mt-0 pt-0 center mb-0"><b>Costo Pratica Base (*) <br /> con Due Diligence  </b></p>

              </div>

            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <h1 class="quardValue center h2  mt-2 pt-0 mb-0"> <b>
                      <font-awesome-icon icon="user-check" size="1x" />
                    </b> </h1>
                  <p class="quardDescription center mb-0"><b>Senza <br/> Criteri di Eleggibilità</b></p>
                </div>
              </div>
            </div>
            <div class="col-6 center  text-center pr-2 pl-2 mt-2">
              <div class="quardContainer bluetify">
                <div class="quardDescription">
                  <!--<h1 class="quardValue center h2 mt-2 pt-0 mb-0"> <b> Scegli </b> </h1>-->
                  <p class="quardDescription center mb-0"><b>Creazione <br/> Preventivi e Pratiche <br/>con comunicazione web cessione credito <br/> da cliente ad installatore </b></p>
                </div>
              </div>
            </div>
          </div>
          <!---   END  QUARD  ZONE        -->
        </div>

      </div>
      <div class="back vaillantCont scrollContainer">
        <h4 class="Regular h2 widthFull mt-0 flowTitle">
          <b>Flusso BASE</b>
        </h4>
        <p class="center h5 mt-2 mb-2 mb-md-3 uppercase red Bold"><b>Senza Cessione del Credito</b> </p>
        <ul class="newBackDesc text-left pt-md-4 ">
          <li>
            Valore nominale standart di cessione: <b>XX %*</b>
            <p class="quardDescription mt-0 pt-0  mb-0 red "><b>modificabile liberalmente dall'aderente  </b></p>
          </li>
          <li>
            <b>Costo Pratica</b> (importo Pratica base)
            <br /> <b>TQSA ≤ € {{ tqsa  }} IVA incl. o Edilizia Libera</b>  <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence e comunicazione web cessione crediti da committente ad aderente: <b>€230+IVA</b>
            <br /> <b>TQSA > € {{ tqsa  }} IVA incl. e NO Edilizia Libera</b>
            <br/>Totale Quota Spesa Agevolabile;
            importo Pratica base; include Due Diligence, Visto di Conformità e comunicazione web cessione crediti da committente ad aderente: <b>€290+IVA</b>
          </li>

          <li>
            Riferimento Bonus Fiscali: <b>EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%</b>
          </li>

          <li>
            Advisor: <b>ADVISOR PARTNER</b>
          </li>
          <li>
            <b class="red">FLUSSO SENZA CESSIONE DEL CREDITO </b>

            <br />
          </li>
        </ul>

      </div>
      <div ref="agen" class="cardFooter">
        <h5 v-if="card3" v-on:click=" toggleCard(3)" class="pointer " :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">
          <font-awesome-icon class="mr-3"  icon="arrow-left" size="1x" /> Indietro
        </h5>
        <h5 v-else v-on:click="toggleCard(3)" class="pointer mb-2 pb-2 mt-2" :class="{'mt-1 pt-1 mb-0 pb-0' : hasSelectButtons, 'mb-2 pb-2 mt-2' : !hasSelectButtons}">Scopri di piu
          <font-awesome-icon class="ml-3" icon="arrow-right" size="1x" />
        </h5>

        <h5 v-if="hasSelectButtons" v-on:click="setChoice('general')" class="center underline pointer brTop mt-0 pt-2">
           <span class="mt-2">Procedi con Flusso Base</span>
        </h5>

      </div>
    </div>

  </div>


</div>

</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  USER_REQUEST,
  USER_SET_DEFAULT_SHIP_DATA
} from 'actions/user'
import Vue from 'vue'

const moment = require('moment')

export default {
  name: 'posteForm',
  components: {

  },
  props: {
    hasSelectButtons: Boolean
  },
  data() {
    return {
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      loadingState: false,
      IbanDB: false,
      card1: false,
      card2: false,
      card3: false,
      card4: false,
      brand: process.env.BRAND,
      tqsa: '10.000',
      cdpState: 'not_active', //not_active, pending, error, active
      aeState: 'not_active',
      mbfactaState: 'not_active',

      iban_cdp: '',
      intestatario_cdp: '',
      iban_ae: '',
      intestatario_ae: '',
      iban_mbfacta: '',
      intestatario_mbfacta: '',

      flow_cdp_active: process.env.FLOW_CDP_ACTIVE,
      cdp_not_active_text: process.env.FLOW_CDP_NOT_ACTIVE_TEXT,
      flow_poste_active: process.env.FLOW_POSTE_ACTIVE,
      poste_not_active_text: process.env.FLOW_POSTE_NOT_ACTIVE_TEXT,

      flow_ae_active: process.env.FLOW_AE_ACTIVE,
      ae_not_active_text: process.env.FLOW_AE_NOT_ACTIVE_TEXT,

      flow_mbfacta_active: process.env.FLOW_MBFACTA_ACTIVE,
      mbfacta_not_active_text: process.env.FLOW_MBFACTA_NOT_ACTIVE_TEXT,


      practic_price_mbfacta: process.env.PRACTIC_PRICE_MBFACTA,
      practic_price_mbfacta_old: process.env.PRACTIC_PRICE_MBFACTA_OLD,
      finance_cost_mbfacta: process.env.FINANCE_COST_MBFACTA,
      min_disposals_price_mbfacta: process.env.MIN_DISPOSAL_PRICE_MBFACTA,


      practic_price_mbfacta_recovery: process.env.PRACTIC_PRICE_MBFACTA_RECOVERY,
      practic_price_mbfacta_recovery_old: process.env.PRACTIC_PRICE_MBFACTA_RECOVERY_OLD,
      finance_cost_mbfacta_recovery: process.env.FINANCE_COST_MBFACTA_RECOVERY,
      min_disposals_price_mbfacta_recovery: process.env.MIN_DISPOSAL_PRICE_MBFACTA_RECOVERY,
      flow_mbfacta_recovery_active: process.env.FLOW_MBFACTA_RECOVERY_ACTIVE,
      mbfacta_recovery_not_active_text: process.env.FLOW_MBFACTA_RECOVERY_NOT_ACTIVE_TEXT,


      practic_price_agileenergy: process.env.PRACTIC_PRICE_AGILEENERGY,
      practic_price_agileenergy_old: process.env.PRACTIC_PRICE_AGILEENERGY_OLD,
      finance_cost_agileenergy: process.env.FINANCE_COST_AGILEENERGY,
      min_disposals_price_agileenergy: process.env.MIN_DISPOSAL_PRICE_AGILEENERGY,

      practice_visto: process.env.PRACTIC_VISTO

    }

  },
  methods: {
    setChoice(val){
      this.$emit('clicked', val)
    },
    setSection(val) {
      this.$router.push({
        path: '/flowSettings/#section' + val,
        query: {
          plan: 'private'
        }
      })
    },
    toggleCard: function(card) {

      if (card == '1') {
        this.card1 = !this.card1
        console.log(this.card1)
      }
      if (card == '2') {
        this.card2 = !this.card2
        console.log(this.card2)
      }
      if (card == '3') {
        this.card3 = !this.card3
        console.log(this.card3)
      }
      if (card == '4') {
        this.card4 = !this.card4
        console.log(this.card4)
      }

    },
    checkStates() {

      if (this.getProfile) {
        // Agile Energy
        this.aeState = this.getProfile.ae_state
        this.iban_ae = this.getProfile.iban_ae
        this.intestatario_ae = this.getProfile.intestatario_ae
        // MB FACTA
        this.mbfactaState = this.getProfile.mbfacta_state
        this.iban_mbfacta = this.getProfile.iban_mbfacta
        this.intestatario_mbfacta = this.getProfile.intestatario_mbfacta

        // CDP
        this.cdpState = this.getProfile.cdp_state
        this.iban_cdp = this.getProfile.iban_cdp
        this.intestatario_cdp = this.getProfile.intestatario_cdp


      }
    }
  },
  watch: {
    async getProfile() {
      await this.checkStates()
    },
  },


  async mounted() {
    this.checkStates()
  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus', 'getProfile']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),

  },
}
</script>

<style lang="css" scoped>
.maxSem{
  max-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/flowSettings/flows.vue